import { useState } from 'react';
import { supabase } from '../utils/supabase';
import { useAuth } from '../context/AuthContext';

interface SuggestedField {
  [key: string]: string | string[] | { [key: string]: string };
}

interface SuggestedCard {
  type: string;
  title: string;
  overview: string;
  suggested_fields: SuggestedField;
}

export const useCardSuggestions = () => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [suggestions, setSuggestions] = useState<SuggestedCard[]>([]);

  const fetchSuggestions = async () => {
    if (!user) return;
    
    setIsLoading(true);
    setError(null);
    
    try {
      const { data, error } = await supabase.functions.invoke('suggest-cards', {
        body: { userId: user.id }
      });

      if (error) throw error;

      setSuggestions(data.suggestions || []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch suggestions');
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    suggestions,
    isLoading,
    error,
    fetchSuggestions
  };
}; 